import { render } from "./Grid.vue?vue&type=template&id=963c7300&scoped=true&ts=true"
import script from "./Grid.vue?vue&type=script&lang=ts"
export * from "./Grid.vue?vue&type=script&lang=ts"

import "./grid.scss?vue&type=style&index=0&id=963c7300&lang=scss&scoped=true"
import "./grid-utility.scss?vue&type=style&index=1&lang=scss"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963c7300"]])

export default __exports__